(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.locale
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.locale', [
      'ui.router'
    ]);
}());
